export const FEATURE_NAMES = [
    'ferret_search',
    'insights_panel_init_open_state',
    'insights_inconsistencies_explanation',
    'insights_inline_inconsistencies',
    'media_player',
    'media_source',
    'backup_recording',
    'prefer_local_audio',
    'term_boosting',
    's3_media_download',
    'show_insights_pre_session_start',
    'insights_offset_strict_highlighting',
    'start_early',
    'order_details_polling',
    'ably_verbose_logs',
    'debug_logs',
    'transcript_doc_cache',
    'absolute_timestamps',
    'allow_all_caps_display',
    // CRDT v2 + editing capabilities epics
    'text_editing',
    'paragraph_split_merge',
    'speaker_tagging',
    'text_highlighting',
    'qac_tagging',
    'grey_out_unfinalized_asr',
    'sendbird_support_chat',
] as const

export type FeatureName = (typeof FEATURE_NAMES)[number]
